module.exports = __webpack_public_path__ + "de494e1ad3f0aba365cc63c5291babf3.png";